import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import { throttle } from '@fund/basic-lib/dist/lib/function';
import { formatDate } from '@fund/basic-lib/dist/lib/date';
// import { setStorage, getStorageSync, removeStorage } from '@fund/storage';
// import { removeStorage } from '@fund/storage';
import native from './modules/native';
import fcache from './modules/fcache';
import baseInfo from './modules/fundhq/baseInfo';
import fundconfg from './modules/fundhq/fundconfg';
import quotation from './modules/fundhq/quotation';
import cfhModules from './modules/fundhq/cfhModules';
import holdasset from './modules/fundhq/holdasset';
import holdhb from './modules/fundhq/holdhb';
import emhq from './modules/fundhq/emhq';
import question from './modules/question';
import news from './modules/news';
import announcement from './modules/announcement';
import dividend from './modules/dividend';
import fundmanager from './modules/fundmanager';
import stokeinfo from './modules/stoke/stokeinfo';
import tradeInfo from './modules/fundhq/tradeInfo';
import detail1 from './modules/detail1';
import overseaInfo from './modules/overseaInfo';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    native,
    stokeinfo,
    baseInfo,
    quotation,
    cfhModules,
    fundmanager,
    fundconfg,
    dividend,
    question,
    news,
    announcement,
    holdhb,
    emhq,
    holdasset,
    fcache,
    tradeInfo,
    detail1,
    overseaInfo,
  },
  state: {
    fundCode: '000001',
    fundType: 'F_H_--',
  },
  mutations: {
  },
  actions: {
  },
  plugins: [createPersistedState({
    storage: {
      // getItem: (key) => {
      //   const res = getStorageSync(key);
      //   // console.log(`getItem length ===== ${res.length} === ${res}`);
      //   if (res && res.length > 16000 * 3) {
      //     removeStorage(key);
      //     return '';
      //   }
      //   return res;
      // },
      // setItem: throttle((key, value) => {
      //   setStorage(key, value);
      // }, 1000, { leading: false }),
      // getItem: (key) => {
      //   // const newData = localStorage.getItem(`FundDetail-${window.fundCode}`);
      //   const newData = localStorage.getItem(key);
      //   console.log(`createPersistedState ========key ${key} ${window.fundCode}`);
      //   return newData;
      // },

      // setItem: (key, value) => {
      //   console.log(`createPersistedState setItem========key ${key} ${window.fundCode}`);
      //   // localStorage.setItem(`FundDetail-${window.fundCode}`, value);
      //   localStorage.setItem(key, value);
      // },
      setItem: throttle((key, value) => {
        if (window.nativeData && window.nativeData.fundCode) {
          const tradeT = formatDate(new Date(), 'yyyy-MM-dd');
          // eslint-disable-next-line no-param-reassign
          const data = value ? JSON.parse(value) : {};
          data.cacheDate = tradeT;
          const jsonStr = JSON.stringify(data);
          try {
            // 存
            window.localStorage.setItem(`${key}-${window.nativeData.fundCode}`, jsonStr);
          } catch (err) {
            console.error(err);
            // 缓存体积大于500K
            if (/quota/igm.test(err)) {
              // 非本日都删了
              const remlist = [];
              Object.keys(window.localStorage)
                .forEach((localkey) => {
                  if (/vuex-/igm.test(localkey)) {
                    const res = localStorage.getItem(localkey);
                    const dataitem = res ? JSON.parse(res) : {};
                    if (dataitem.cacheDate !== tradeT) {
                      remlist.push(localkey);
                    }
                  }
                });
              remlist.forEach((removekey) => {
                window.localStorage.removeItem(removekey);
              });
            }
          }
        }
      }, 1000, { leading: false }),
      // getItem: (key) => localStorage.getItem(key),
      // setItem: (key, value) => localStorage.setItem(key, value),
      removeItem: (key) => {
        window.localStorage.removeItem(key);
      },
    },
  })],
});
